import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Message from '../common/message';
import utilFunction from '../../containers/function';
import TagsDisplay from '../common/driver/tagsDisplay';

// function created for severity
const colorSeverityItem = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return 'gris';
  } else if (severety.toUpperCase() === 'REJECTED') {
    return 'red';
  } else if (severety.toUpperCase() === 'ACCEPTED') {
    return 'green';
  } else if (severety.toUpperCase() === 'FAIR') {
    return 'yellow';
  } else if (severety.toUpperCase() === 'WITHOUTINFORMATION') {
    return 'purple';
  }
  return 'gris';
};

// function created for severity
const iconSeverityItem = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return '';
  } else if (severety.toUpperCase() === 'REJECTED') {
    return 'exclamation-circle';
  } else if (severety.toUpperCase() === 'ACCEPTED') {
    return 'check-circle';
  } else if (severety.toUpperCase() === 'FAIR') {
    return 'exclamation-circle';
  } else if (severety.toUpperCase() === 'WITHOUTINFORMATION') {
    return 'exclamation-circle';
  }
  return 'gris';
};

// function created for severity
const returnWarningVersions = (otherKpis,language) => {
  for(var i=0;i<otherKpis.length;i++) {
    var kpi = otherKpis[i];
    if(kpi.key=="Version" && kpi.value>=2) {
      return (
        <div className="warning-version modal-indicators-info left">
          <a>
            {kpi.value}
            <div>
              <p>{language.summary.ffdPvt.lastDataView.Version}</p>
            </div>
          </a>
        </div>
      );
    }
  }
  return null;
};

const Table = props => (
  <div className="module-table top">
    <table>
      <thead>
        <tr>
          <th className="th-name left">
            <a
              role="button"
              data-type="alias"
              tabIndex={0}
              onClick={props.handleSort}
              className="th100 helpsortth"
            >
              {props.language.summary.ffdPvt.lastDataView.name}
              <div className="sort-icons">
                <div className="sort-icons-inner">
                  <i className={"fas fa-caret-up " + 
                    (props.sort["alias"]=="ASC" ? "active" : "")}/>
                  <i className={"fas fa-caret-down " + 
                    (props.sort["alias"]=="DESC" ? "active" : "")}/>
                </div>
              </div>             
            </a>
          </th>
          {props.filter.map(item => (
            <th className="th-category left" key={item.name}>
              <a
                role="button"
                data-type={"category"}
                data-cat={item.name}
                tabIndex={0}
                onClick={props.handleSort}
                className="th100 helpsortth"
              >
                {props.language.filter[item.name.toLowerCase()]}
                <div className="sort-icons">
                  <div className="sort-icons-inner">
                    <i className={"fas fa-caret-up " + 
                      ((props.sort["category"]=="ASC" 
                        && props.tagCategorySort==item.name) ? "active" : "")}/>
                    <i className={"fas fa-caret-down " + 
                      ((props.sort["category"]=="DESC" 
                        && props.tagCategorySort==item.name) ? "active" : "")}/>
                  </div>
                </div>
                <div className="modal-indicators-info">
                  <a>
                    <i className="fas fa-question-circle" />
                    <div>
                      <p>{props.language.summary.ffdPvt.lastDataView.categoriesHelp}</p>
                    </div>
                  </a>
                </div>              
              </a>
            </th>
          ))}
          <th className="th-group left">
            <a role="button" className="helpsortth" data-type="group" tabIndex={0} onClick={props.handleSort}>
              {props.language.summary.ffdPvt.lastDataView.workingShiftGroup}
              <div className="sort-icons">
                <div className="sort-icons-inner">
                  <i className={"fas fa-caret-up " + 
                    (props.sort["group"]=="ASC" ? "active" : "")}/>
                  <i className={"fas fa-caret-down " + 
                    (props.sort["group"]=="DESC" ? "active" : "")}/>
                </div>
              </div>
              <div className="modal-indicators-info">
                <a>
                  <i className="fas fa-question-circle" />
                  <div>
                    <p>{props.language.summary.ffdPvt.lastDataView.workingShiftGroupHelp}</p>
                  </div>
                </a>
              </div>
            </a>
          </th>
          <th className="th-score right fix-super-wide">
            <a role="button" className="helpsortth" data-type="ffdScore" tabIndex={0} onClick={props.handleSort}>
              {props.language.summary.ffdPvt.lastDataView.ffdScore}
              <div className="sort-icons">
                <div className="sort-icons-inner">
                  <i className={"fas fa-caret-up " + 
                    (props.sort["ffdScore"]=="ASC" ? "active" : "")}/>
                  <i className={"fas fa-caret-down " + 
                    (props.sort["ffdScore"]=="DESC" ? "active" : "")}/>
                </div>
              </div>
              <div className="modal-indicators-info">
                <a className="green">
                  <i className="fas fa-question-circle" />
                  <div>            
                    <p>{props.language.summary.ffdPvt.lastDataView.ffdScoreHelp}</p>
                    <p>
                      <span className="green">
                      {props.language.summary.ffdPvt.lastDataView.ACCEPTED + ": "}
                      </span> 
                      {props.language.summary.ffdPvt.lastDataView.ACCEPTEDHelp}
                    </p>
                    <p>
                      <span className="yellow">
                      {props.language.summary.ffdPvt.lastDataView.FAIR + ": "}
                      </span> 
                      {props.language.summary.ffdPvt.lastDataView.FAIRHelp}
                    </p>
                    <p>
                      <span className="red">
                      {props.language.summary.ffdPvt.lastDataView.REJECTED + ": "}
                      </span> 
                      {props.language.summary.ffdPvt.lastDataView.REJECTEDHelp}
                    </p>
                    <p>
                      <span className="purple">
                      {props.language.summary.ffdPvt.lastDataView.NODATA + ": "}
                      </span> 
                      {props.language.summary.ffdPvt.lastDataView.NODATAHelp}
                    </p>
                  </div>
                </a>
              </div>            
            </a>
          </th>
          <th className="th-date right">
            <a role="button" className="helpsortth" data-type="calcDate" tabIndex={0} onClick={props.handleSort}>
              {props.language.summary.ffdPvt.lastDataView.calcDate}
              <div className="sort-icons">
                <div className="sort-icons-inner">
                  <i className={"fas fa-caret-up " + 
                    (props.sort["calcDate"]=="ASC" ? "active" : "")}/>
                  <i className={"fas fa-caret-down " + 
                    (props.sort["calcDate"]=="DESC" ? "active" : "")}/>
                </div>
              </div>
              <div className="modal-indicators-info">
                <a>
                  <i className="fas fa-question-circle" />
                  <div>
                    <p>{props.language.summary.ffdPvt.lastDataView.calcDateHelp}</p>
                  </div>
                </a>
              </div>            
            </a>
          </th>
          <th className="th-info">
            <a className="noLink">
              {props.language.summary.ffdPvt.lastDataView.fitnessForDuty}
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        {props.datos.map((item, i) => {
          return (
            <tr
              key={`${i}`}
              data-datos={JSON.stringify(item)}
              className="hover"
            >
              {/* Name */}
              <td className="td-name first"><div><div>
                <span className={`${colorSeverityItem(item.result)} font16`} />
                {item.name}
              </div></div></td>
              {props.filter.map(cat => {
                let tags = [];
                for(var i=0; i<item.tagsList.length; i++) {
                  var tagsObject = item.tagsList[i];
                  if(tagsObject.category.toUpperCase() == cat.name.toUpperCase()) {
                    tags = tagsObject.tags;
                  }
                }
                return (
                  <td className={"td-category left"} key={cat.name}><div><div>
                    {tags.join(", ")}
                  </div></div></td>
                );
              })}
              <td className="td-group left"><div><div>{item.group}</div></div></td>
              <td className="td-score right"><div><div>
                <p className={colorSeverityItem(item.result)}>
                  {item.result 
                    && item.result.toUpperCase() == "WITHOUTINFORMATION" ? 
                      "--" : (item.result ? item.value : "")}
                </p>
              </div></div></td>
              <td className="td-date right"><div><div>{item.ffdGenerationDate ? 
                (utilFunction.getFormatFunction(
                  {type:"PARSE_DATE_STRING",format:[`${props.language.account.date.graphFormatTooltip} %H:%M:%S`,"%Y-%m-%d %H:%M:%S"]}
                ))(item.ffdGenerationDate)
                : ""}
              </div></div></td>
              <td className="td-info" >
                <div className={colorSeverityItem(item.result)}>
                  {returnWarningVersions(item.otherKpis,props.language)}
                  <div>
                    <i className={"fas fa-"+iconSeverityItem(item.result)}/>
                  </div>
                  <div className="ffdpopup">
                    <table>
                    <tbody>
                    {item.otherKpis.map(other => (
                      <tr key={other.key}>                        
                        <td><strong>{props.language.summary.ffdPvt.lastDataView[other.key]}</strong></td>
                        <td>{((other.key=="LastRealizationDate" || other.key=="FirstRealizationDate") 
                          && other.value) ? 
                          (utilFunction.getFormatFunction(
                            {type:"PARSE_DATE_STRING",format:[`${props.language.account.date.graphFormatTooltip} %H:%M:%S`,"%Y-%m-%d %H:%M:%S"]}
                          ))(other.value) 
                          : (other.key=="FirstResult" 
                          && other.value) ? props.language.summary.ffdPvt.lastDataView[other.value.toUpperCase()]
                          : other.value}</td>
                      </tr>
                    ))}
                    {(item.faults!=null) && (
                      <tr>
                        <td><strong>{props.language.summary.ffdPvt.lastDataView.rejectReasons}</strong></td>
                        <td>
                          {item.faults.map((fault,index) => {
                            var text = props.language.summary.ffdPvt.lastDataView[fault.key];
                            var separator = "";
                            if(index<(item.faults.length-1)) {
                              separator = ", ";
                            }
                            if(fault.hasDetail) {
                              return (
                                <span key={"fault"+index}>
                                  <span 
                                    onClick={props.handleFaultDetail}
                                    data-faultdetail={fault.value}
                                    data-faulttitle={text}                                    
                                    data-close="ok"
                                    className={"fault-detail-link"}>
                                    {text}
                                  </span>
                                  {separator}
                                </span>
                              );
                            }
                            else {
                              return (
                                <span key={"fault"+index}>{text}{separator}</span>
                              );
                            }
                          })}
                        </td>
                      </tr>
                    )}
                    </tbody>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    {props.loadingTable && (
      <div className="loading-table">
        <h6>
          <i className="fas fa-spinner fa-spin" />
        </h6>
      </div>
    )}
    {props.pag >= props.count.pages && (
      <div className="loading-table">
        <h6>{props.language.summary.ffdPvt.FFDRealization.noData}</h6>
      </div>
    )}
  </div>
);

Table.propTypes = {
  pag: PropTypes.number.isRequired,
  count: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  loadingTable: PropTypes.bool.isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired,
  datos: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array
  ]).isRequired
};

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/last_data_ffd_pvt/table.jsx